module.exports = __webpack_public_path__ + "img/SKMA_noCar.0ab5c62d.png";